import { render, staticRenderFns } from "./WlogTotal.vue?vue&type=template&id=03bdadfa"
import script from "./WlogTotal.vue?vue&type=script&lang=js"
export * from "./WlogTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports